import React from 'react'
import { Text, View, useStyles } from '@ion-ui/core'
import { useMediaQuery } from 'react-responsive'
import { Styles } from './styles'

const StepsCard = ({ index, title, description }) => {
  const styles = useStyles(Styles)
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  return (
    <View css={styles.cardContent}>
      <Text variant={isMobile ? 'h2' : 'h1'} css={styles.indexStyle}>{index}</Text>
      <View>
        <Text variant='h6' css={styles.titleStyle}>{title}</Text>
        <Text variant='paragraph'>{description}</Text>
        {index === 4
          ? <Text variant='caption2' css={styles.littleText}>*Sujeto a recepción de documentación completa</Text>
          : null
        }
      </View>
    </View>
  )
}

export default StepsCard
